module.exports = __webpack_public_path__ + "img/4.6e05eab6.png";